import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { IModule } from "../GestionFonctionnalite/Module/moduleSlice";
import Chip from "@mui/material/Chip";
import {
  IFonctionnalite,
  setFilterFonctionnalites,
  setFonctionnalites,
} from "../GestionFonctionnalite/Fonctionnalite/fonctionnaliteSlice";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export default function VisualiserFonctionnalite(props: any) {
  const { data, deleteItem, setItem, handleEditDialogOpen } = props;

  const dispatch = useDispatch();
  const { filterfonctionnalites } = useSelector(
    (state: IReduxState) => state.fonctionnalite
  );

  //hooks
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const theme = useTheme();
  const modeEcran = useMediaQuery(theme.breakpoints.down("lg"));

  const handleListItemClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    index: any,
    item: IModule
  ) => {
    setSelectedIndex(index);
    dispatch(setItem(item));
  };

  //les groupe fonctionnalites
  const getFonctionnalitesData = async () => {
    try {
      const res: any = await apiClient.get(
        ADMIN_SERVER_BASE_URL,
        "/tablesystem/listefonctionnalite"
      );
      if (res.status === 1) {
        const x = res.data.map((f: IFonctionnalite) => {
          return {
            ...f,
            id: f.idFonctionnalite,
            libelle: f.libelleFonctionnalite,
          };
        });
        dispatch(setFonctionnalites(x));
        dispatch(setFilterFonctionnalites(x));
      } else {
        console.log("status !==1");
      }
    } catch (error) {
      console.log("🚀 ~ file: Accueil.tsx ~ line 46 ~ getDatas ~ error", error);
    }
  };

  React.useEffect(() => {
    getFonctionnalitesData();
  }, []);

  return (
    <Box
      sx={{ flexGrow: 1 }}
      style={{
        height: "60vh",
        overflow: "auto",
        marginTop: modeEcran ? 50 : 0,
        paddingRight: 10,
      }}
    >
      <List dense={true}>
        {filterfonctionnalites.map((item: any, index: any) => {
          return (
            <div key={index}>
              <ListItem
                secondaryAction={
                  <Chip label={item.id} color="primary" variant="outlined" />
                }
              >
                <ListItemButton selected={selectedIndex === index}>
                  <ListItemText
                    onClick={(event) => console.log("aaaaaa")}
                    primary={item.libelle}
                    secondary={item.descriptionFonctionnalite}
                  />
                </ListItemButton>
              </ListItem>
              <Divider />
            </div>
          );
        })}
      </List>
    </Box>
  );
}
